import { GateMovementState2 as MovementState } from '@/__generated__/graphql';
import { type I18n } from '@lingui/core';
import { t } from '@lingui/macro';

const FINALIZED_STATES = [MovementState.Finalized, MovementState.FinalizedWithError];
const INITIALIZING_STATES = [MovementState.InQueue, MovementState.Initializing];

export const translateMovementState = (state: MovementState, i18n: I18n) => {
  const translationMap: Record<MovementState, string> = {
    [MovementState.InQueue]: t(i18n)`En cola`,
    [MovementState.Initializing]: t(i18n)`Inicializando`,
    [MovementState.InMovement]: t(i18n)`En movimiento`,
    [MovementState.Finalized]: t(i18n)`Finalizada`,
    [MovementState.FinalizedWithError]: t(i18n)`Finalizada con error`,
  };
  return translationMap[state];
};

export const isFinalizedState = (state: MovementState) => {
  return FINALIZED_STATES.includes(state);
};

export const isInitializingState = (state: MovementState) => {
  return INITIALIZING_STATES.includes(state);
};

type MovementStateColor = {
  color: string;
  contrastColor: string;
};

export const getStateColor = (state: MovementState) => {
  const whiteColors: MovementStateColor = {
    color: '#ffffff',
    contrastColor: '#000000',
  };

  const greenColors: MovementStateColor = {
    color: '#26A69A',
    contrastColor: '#ffffff',
  };

  const redColors: MovementStateColor = {
    color: '#923E4A',
    contrastColor: '#ffffff',
  };

  const colorMap: Record<MovementState, MovementStateColor> = {
    [MovementState.InQueue]: whiteColors,
    [MovementState.Initializing]: whiteColors,
    [MovementState.InMovement]: whiteColors,
    [MovementState.Finalized]: greenColors,
    [MovementState.FinalizedWithError]: redColors,
  };

  return colorMap[state];
};
